export default [
  {
    category: 'SuperStar',
    name: 'Takuya Noguchi',
    gitlab: 'https://gitlab.com/tnir',
    merged_mrs: 335,
  },
  {
    category: 'SuperStar',
    name: 'Rajendra kadam',
    gitlab: 'https://gitlab.com/raju249',
    merged_mrs: 277,
  },
  {
    category: 'SuperStar',
    name: 'Ben Bodenmiller',
    gitlab: 'https://gitlab.com/bbodenmiller',
    merged_mrs: 224,
  },
  {
    category: 'SuperStar',
    name: 'Gilang Gumilar',
    gitlab: 'https://gitlab.com/gilangmlr',
    merged_mrs: 119,
  },
  {
    category: 'SuperStar',
    name: 'Jonston Chan',
    gitlab: 'https://gitlab.com/JonstonChan',
    merged_mrs: 81,
  },
  {
    category: 'Star',
    name: 'Marvin Karegyeya ',
    gitlab: 'https://gitlab.com/nuwe1',
    merged_mrs: 64,
  },
  {
    category: 'Star',
    name: 'Kev',
    gitlab: 'https://gitlab.com/KevSlashNull',
    merged_mrs: 59,
  },
  {
    category: 'Star',
    name: 'Edmund Ochieng',
    gitlab: 'https://gitlab.com/ochienged',
    merged_mrs: 52,
  },
  {
    category: 'Star',
    name: 'Lee Tickett',
    gitlab: 'https://gitlab.com/leetickett',
    merged_mrs: 52,
  },
  {
    category: 'Star',
    name: 'Rachel Gottesman',
    gitlab: 'https://gitlab.com/gottesman.rachelg',
    merged_mrs: 41,
  },
  {
    category: 'Star',
    name: 'Diego Louzán',
    gitlab: 'https://gitlab.com/dlouzan',
    merged_mrs: 26,
  },
  {
    category: 'Star',
    name: 'Roger Meier',
    gitlab: 'https://gitlab.com/bufferoverflow',
    merged_mrs: 23,
  },
  {
    category: 'Star',
    name: 'Mathieu Parent',
    gitlab: 'https://gitlab.com/sathieu',
    merged_mrs: 21,
  },
  {
    category: 'Star',
    name: 'Rachel Fox',
    gitlab: 'https://gitlab.com/rachelfox',
    merged_mrs: 21,
  },
  {
    category: 'Star',
    name: 'Sashi Kumar',
    gitlab: 'https://gitlab.com/ksashikumar',
    merged_mrs: 21,
  },
  {
    category: 'Star',
    name: 'Ethan Reesor',
    gitlab: 'https://gitlab.com/firelizzard',
    merged_mrs: 20,
  },
  {
    category: 'Star',
    name: 'George Tsiolis',
    gitlab: 'https://gitlab.com/gtsiolis',
    merged_mrs: 19,
  },
  {
    category: 'Star',
    name: 'Lucy Fox',
    gitlab: 'https://gitlab.com/lucyfox',
    merged_mrs: 18,
  },
  {
    category: 'Star',
    name: 'Matthias van de Meent',
    gitlab: 'https://gitlab.com/matthias.vandemeent',
    merged_mrs: 17,
  },
  {
    category: 'Star',
    name: 'Pirate Praveen',
    gitlab: 'https://gitlab.com/pravi',
    merged_mrs: 16,
  },
  {
    category: 'Star',
    name: 'Fabio Huser',
    gitlab: 'https://gitlab.com/fh1ch',
    merged_mrs: 15,
  },
  {
    category: 'Star',
    name: 'Harrison Healey',
    gitlab: 'https://gitlab.com/hmhealey',
    merged_mrs: 15,
  },
  {
    category: 'Star',
    name: 'Jacopo Beschi',
    gitlab: 'https://gitlab.com/jacopo-beschi',
    merged_mrs: 14,
  },
  {
    category: 'Star',
    name: 'Brian Kabiro',
    gitlab: 'https://gitlab.com/briankabiro',
    merged_mrs: 13,
  },
  {
    category: 'Star',
    name: 'Stefan Schmalzhaf',
    gitlab: 'https://gitlab.com/the_s',
    merged_mrs: 13,
  },
  {
    category: 'Star',
    name: 'David Barr',
    gitlab: 'https://gitlab.com/davebarr',
    merged_mrs: 12,
  },
  {
    category: 'Star',
    name: 'Jan',
    gitlab: 'https://gitlab.com/kingjan1999',
    merged_mrs: 12,
  },
  {
    category: 'Star',
    name: 'Lakshit',
    gitlab: 'https://gitlab.com/lakshit1',
    merged_mrs: 12,
  },
  {
    category: 'Star',
    name: 'J0WI',
    gitlab: 'https://gitlab.com/J0WI',
    merged_mrs: 11,
  },
  {
    category: 'Enthusiast',
    name: 'Dmitry Chepurovskiy',
    gitlab: 'https://gitlab.com/dm3ch',
    merged_mrs: 10,
  },
  {
    category: 'Enthusiast',
    name: 'Fabio Matavelli',
    gitlab: 'https://gitlab.com/fabiomatavelli',
    merged_mrs: 10,
  },
  {
    category: 'Enthusiast',
    name: 'Arun Kumar Mohan',
    gitlab: 'https://gitlab.com/auua',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Brittany Garcia',
    gitlab: 'https://gitlab.com/brittany_garcia',
    merged_mrs: 9,
  },
  {
    category: 'Enthusiast',
    name: 'Lee',
    gitlab: 'https://gitlab.com/ohaddahan',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Raihan Kabir',
    gitlab: 'https://gitlab.com/rk4bir',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Wilson Barr',
    gitlab: 'https://gitlab.com/texbarr',
    merged_mrs: 8,
  },
  {
    category: 'Enthusiast',
    name: 'Avi Chazen',
    gitlab: 'https://gitlab.com/avichazen',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Iniubong Obonguko',
    gitlab: 'https://gitlab.com/codiini',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Max Wittig',
    gitlab: 'https://gitlab.com/max-wittig',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Peter Dave Hello',
    gitlab: 'https://gitlab.com/PeterDaveHello',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Son Luong Ngoc',
    gitlab: 'https://gitlab.com/sluongng',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'gaga5lala',
    gitlab: 'https://gitlab.com/gaga5lala1013',
    merged_mrs: 7,
  },
  {
    category: 'Enthusiast',
    name: 'Andrew McGivery',
    gitlab: 'https://gitlab.com/andrewmcgivery',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Arthur de Lapertosa Lisboa',
    gitlab: 'https://gitlab.com/arthurlapertosa',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Daniel Coutinho de Miranda',
    gitlab: 'https://gitlab.com/DanielCMiranda',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Horatiu Eugen Vlad',
    gitlab: 'https://gitlab.com/hvlad',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'James Tharpe',
    gitlab: 'https://gitlab.com/jamestharpe',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Justin Zeng',
    gitlab: 'https://gitlab.com/jzeng88',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Pedro Pombeiro',
    gitlab: 'https://gitlab.com/pedropombeiro',
    merged_mrs: 6,
  },
  {
    category: 'Enthusiast',
    name: 'Ali Mirlou',
    gitlab: 'https://gitlab.com/AliMirlou',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Amelia Paik',
    gitlab: 'https://gitlab.com/AmeliaYura',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Andrei Kyrnich',
    gitlab: 'https://gitlab.com/kyrnich',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Carlos Panato',
    gitlab: 'https://gitlab.com/cpanato',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Elan Ruusamäe',
    gitlab: 'https://gitlab.com/glensc',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Guillaume Gardet',
    gitlab: 'https://gitlab.com/ggardet',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Guillaume Grossetie',
    gitlab: 'https://gitlab.com/g.grossetie',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Gwen',
    gitlab: 'https://gitlab.com/Gwen_',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Harrison Brock',
    gitlab: 'https://gitlab.com/harrisonbrock',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Harry Kiselev',
    gitlab: 'https://gitlab.com/harrykiselev',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Jim Cser',
    gitlab: 'https://gitlab.com/jimcser',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Matthew Briedenhann',
    gitlab: 'https://gitlab.com/matthewbried',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Pavel Kuznetsov',
    gitlab: 'https://gitlab.com/kpd200081',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Ravishankar Gnanaprakasam',
    gitlab: 'https://gitlab.com/ravishankar2kool',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Sharlene Tan',
    gitlab: 'https://gitlab.com/sharlatan',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Stefanie Saffern',
    gitlab: 'https://gitlab.com/stefaniesaffern',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Tsegaselassie Tadesse',
    gitlab: 'https://gitlab.com/tsega',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Vicken Simonian',
    gitlab: 'https://gitlab.com/vicken.papaya',
    merged_mrs: 5,
  },
  {
    category: 'Enthusiast',
    name: 'Łukasz Groszkowski',
    gitlab: 'https://gitlab.com/falxcerebri',
    merged_mrs: 5,
  },
];
